/**
 * Created by hp on 2017/7/16.
 */
import React, {Component} from 'react';
import {Mask, Button} from "react-weui";
import '../styles/components/WKBottomSheet.css';

class WKBottomSheet extends Component {
    render() {
        const {handleSubmit, handleClose, text, children} = this.props;

        return (
            <div className="wk-bottom-sheet">
                <Mask onClick={handleClose}/>
                <div className="wk-bottom-sheet-container">
                    {children}
                    <Button onClick={handleSubmit}>{text}</Button>
                </div>
            </div>
        )
    }
}

export default WKBottomSheet;



// WEBPACK FOOTER //
// ./src/components/WKBottomSheet.js